import React from 'react';

import AppContentError from './AppContentError';
import { useCurrentToolDisplayName } from '../../hooks/useCurrentToolDisplayName';
import i18n from '../../utils/i18n';

const ToolContentError = () => {
  const toolName = useCurrentToolDisplayName();

  return (
    <AppContentError
      description={
        toolName
          ? i18n.t('TOOL_IS_CURRENTLY_UNAVAILABLE', { toolName })
          : undefined
      }
    />
  );
};

export default ToolContentError;
